import React, { useState } from 'react';
import {
  defaultReportColumns,
  itemReportExportSettings,
  ITEM_REPORT_TABLE,
  ITEM_REPORT_TABLE_CONFIG,
  refundItemsExportSettings,
  REFUND_ITEM_TABLE_CONFIG,
  orderItemReportExportSettings,
} from './itemReportTable';
import ReportComponent from '../reportComponent';
import PATH from '$business/enums/paths';
import intl from '$intl';
import { ITEM_REPORT, ORDER_ITEM_REPORT } from '$fbusiness/enums/columns';
import SkuFilter from './skuFilter';
import { getEl } from '$gbusiness/helpers/input';
import { ORDER_STATUS_FILTER } from '../orderReportScreen/orderStatusFilter';
import ListDragSelector from '$gcomponents/reusables/listDragSelector';

interface ItemReportMainProps {
  factory;
  history;
  match;
  stores;
  columns;
  orderFlag?: boolean;
  dateFilter;
}

export const ItemReportMain: React.FC<ItemReportMainProps> = ({
  factory,
  history,
  columns,
  dateFilter,
  stores,
  orderFlag = false,
  match,
}) => {
  const {
    params: { top, no, refund },
  } = match;
  const isRanking = top && no;
  const rank = parseInt(no || 0);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [skuList, setSkuList] = useState<Array<any>>([]);
  const [selectedSkuIndices, setSelectedSkuIndices] = useState<Array<any>>([]);

  const handleRowClick = (itemId) => {
    if (refund) {
      history.push(PATH.REPORT_REFUND_DETAILS + '/1/0/0/' + itemId);
      return;
    }
    history.push(PATH.REPORT_ITEM_DETAILS + '/0/0/' + itemId);
  };

  const onTableLoad = (total, newTotal, response) => {
    if (isRanking) return;
    setSkuList(Object.entries(response.skus).map(([sku, name]) => ({ value: sku, label: name })));
    // Display Summary info
  };

  // const on;

  let titleText;
  if (top === 'bottom') titleText = intl('SCREEN.REPORT.TITLE_BOTTOM', { no: rank });
  if (top === 'top') titleText = intl('SCREEN.REPORT.TITLE_TOP', { no: rank });
  if (refund) titleText = intl('SCREEN.REPORT.TITLE_REFUND_ITEM');

  let reportColumns = columns ? columns[ITEM_REPORT] || defaultReportColumns : defaultReportColumns;
  let exportSettings = refund
    ? refundItemsExportSettings(top, reportColumns)
    : itemReportExportSettings(top, reportColumns);
  const tableConfig = refund ? REFUND_ITEM_TABLE_CONFIG : ITEM_REPORT_TABLE_CONFIG(orderFlag);

  if (orderFlag) {
    reportColumns = columns[ORDER_ITEM_REPORT] || defaultReportColumns;
    exportSettings = orderItemReportExportSettings(reportColumns);
  }

  const onClickFilter = () => {
    setShowFilterModal(true);
  };

  const onSubmitFilter = async (arr) => {
    setSelectedSkuIndices(arr);
    const el = getEl('.submit-button.filter');
    if (el) el.click();
  };

  const titleKey = orderFlag ? 'SCREEN.REPORT.TITLE_ORDER' : 'SCREEN.REPORT.TITLE_ITEM';

  return (
    <>
      <ReportComponent
        title={titleKey}
        titleText={titleText}
        columns={reportColumns}
        columnKey={ITEM_REPORT}
        table={ITEM_REPORT_TABLE({ handleRowClick, isRanking, isRefund: !!refund, orderFlag })}
        tableConfig={tableConfig}
        includeReportType
        tableSummary={
          <SkuFilter show={!isRanking} onClick={onClickFilter} totalCount={selectedSkuIndices.length} />
        }
        onTableLoad={onTableLoad}
        dateFilter={{
          ...dateFilter,
          ...(top && { top: top.toUpperCase() + no }),
          ...(orderFlag && { status: 'PREPARING' }),
          skus:
            selectedSkuIndices.length > 0
              ? selectedSkuIndices.map((l) => ({ sku: skuList[l].value, name: skuList[l].label }))
              : undefined,
        }}
        extraForm={orderFlag ? ORDER_STATUS_FILTER(factory?.vendors) : undefined}
        stores={stores}
        exportSetting={exportSettings}
      />
      <ListDragSelector
        originalList={skuList}
        selectedIndices={selectedSkuIndices}
        onSubmitFilter={onSubmitFilter}
        show={showFilterModal}
        onClose={() => setShowFilterModal(false)}
      />
      {/* <SkuFilterModal
        skuList={skuList}
        onSubmitFilter={onSubmitFilter}
        show={showFilterModal}
        onClose={() => setShowFilterModal(false)}
      /> */}
    </>
  );
};
